<template>
  <div class="mw-panel commonOuterOrg">
    <mw-dialog ref="titleDialog" :title=" form.id ? $lang('编辑个人外单位') : $lang('新建个人外单位') " :close-on-click-modal="false">

      <div class="mw-toolbar">
        <el-button type="primary" @click="closeTitleDialog">
           <i class="fa fa-mail-reply "></i> {{$lang('关闭')}}</el-button>
        <el-button  type="primary" @click="saveTitle"> <i class="fa fa-file-text-o"></i>
          {{$lang('保存')}}</el-button>
      </div>

       <div class="mw-toolbar__body">

          <template>
            <el-row>
              <el-form label-width="130px"  ref="ruleForm" :model="form" :rules="formRules">
                <el-col :span="24" >
                  <el-form-item :label="$lang('所属单位')" prop="unitName">
                    <el-input v-model="form.unitName" style="width: 80%" readonly></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="所属单位ID"  v-show="false">
                    <el-input v-model="form.unitId" style="width: 80%" ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位分类')" prop="code">
                    <el-input v-model="form.code"  style="width:80%"></el-input>
                  </el-form-item>

                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位名称')" prop="name">
                    <el-input v-model="form.name" style="width:80%"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位英文名称')" prop="Englishname">
                    <el-input v-model="form.Englishname" style="width:80%"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位序列')">
                    <el-input-number v-model="form.sn" :controls="false"  :min="1" style="width:80%"></el-input-number>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="$lang('外单位编号')" prop="identifier">
                    <el-input v-model="form.identifier" style="width:80%" ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
        </template>
        </div>
      </mw-dialog>
    <split-pane :defaultSize="220" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button v-show="expandFlag==1" @click="expand" size="mini"><i class="fa fa-angle-double-down"></i>{{$lang('展开')}}</el-button>
            <el-button v-show="expandFlag!=1" @click="closed" size="mini"><i class="fa fa-angle-double-up"></i>{{$lang('折叠')}}</el-button>
          </div>
          <div>
            <mw-tree :url="outerOrgTreeUrl" :autoLoad="false" :async="true"  :multipleLeaf="true"
                     :dragEnable="true" :defaultParams="defaultTreeParams"  :expandedFirst="true" ref="groupTree" @changed="changed"  :selectFirst="true" ></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <toolbar-table :layout="layout"  ref="aa" :pagination="false">
            <span slot="dropDown" v-show="userInfo.unitAdmin ||!isLimit">
              <el-dropdown trigger="hover" @command="handleSortCommand" v-show="userInfo.unitAdmin ||!isLimit">
                <el-button class="el-dropdown-link">
                 {{$lang('排序')}}<i class="el-icon-caret-bottom el-icon--right"></i>
                </el-button>
                <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                  <el-dropdown-item command="sort" >{{$lang('排序')}}</el-dropdown-item>
                  <el-dropdown-item command="top">{{$lang('置顶')}}</el-dropdown-item>
                  <el-dropdown-item command="bottom">{{$lang('置底')}}</el-dropdown-item>
                  <el-dropdown-item command="up">{{$lang('上移')}}</el-dropdown-item>
                  <el-dropdown-item command="down"> {{$lang('下移')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </toolbar-table>
        </div>
      </template>
    </split-pane>
  </div>
</template>
<script>
  import loadUsers from './user/loadUsers'
  import { mapGetters } from 'vuex';
  export default {
      name: 'personal-outer-org',
    components: {
      loadUsers
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'expUser'
      ])
    },
    data() {
      let me = this;
      return {
        isLimit : false,
        layout: [],
        selectUnitId: '',
        form:{
          id:'',
          code: '外单位',
          name: '',
          Englishname: '',
          sn: 1,
          unitName: '',
          unitId:'',
          create_user:'',
          identifier:''
        },
        expandFlag:2,
        outerOrgTreeUrl:this.mwUrl('/api/org/getGroupTreeByType'),
        defaultTreeParams:{type:'personal_outerOrg'},
        selCode:'',
        selUnitId:'',
        selUnitName:'',
        formRules:{
          unitName:[
            {required: true, message:$lang("请选择所属单位"), trigger: 'change'}
          ],
          name:[
            {required: true, message:$lang("请输入外单位名称"), trigger: 'blur'}
          ]
        },
        defaultParams:{
           type:'personal_outerOrg'
         }
      }
    },
    mounted() {
       let me = this;
       if(!this.userInfo.developer){
          if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
            this.defaultParams.unitId= this.$store.getters.curUnit[0].id;
          }
        }else{
            this.defaultParams.unitId= this.userInfo.owner;
        }
        this.defaultTreeParams.create_user = this.userInfo.loginId;
        this.defaultParams.create_user = this.userInfo.loginId;
        me.layout = [
           [{
           span:0,
           type: 'menu',
           label: $lang('个人外单位管理'),
           api: 'org.listGroupDataByType',
           defaultParams:me.defaultParams,
           columns: [
            {type: 'selection'},{prop:'sn',width:'55',label:$lang('序号')},
            {prop: 'name',label: $lang('外单位名称'),slot:{type:"href",func:me.openForm}},
            {prop: 'Englishname',label: $lang('外单位英文名称'),width:'220',tooltip: true},
            {prop: 'identifier',label: $lang('外单位编号'),width:'130',tooltip:true}
          ]
         },{
           span: 14,
           type: 'button',
           items: [{
             label: $lang('添加'),
             func: me.addTitle
           },{
             label: $lang('删除'),
             func: me.deleteGroup,
             icon:"el-icon-delete"
           }],suffixSlot:"dropDown"
         },{
           span: 6,
           type: 'searchText',
           name:'name',
           tip:$lang('外单位名称'),
           offset: 4,
           func: me.search
         }]
       ]
       this.mwRef('groupTree').renderTree();
     },
    methods: {
      changed(data){
        let me =this;
        if(!data.id){
          return;
        }
        let unitText = "";
        if(data.code){
          me.defaultParams.unitId = data.unitId;
          unitText = data.unitName;
          me.defaultParams.code = data.code;
          me.selCode = data.code;
        }else{
          delete me.defaultParams.code;
          me.selCode = "";
          me.defaultParams.unitId = data.id;
          unitText = data.text;
        }
        me.selUnitId = me.defaultParams.unitId;
        me.selUnitName = unitText;
        me.reloadData();
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('groupTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('groupTree').closeAll();
      },
      reloadData(){
        var me = this;
        var tableObj = me.mwRef('aa');
        if(!tableObj || !tableObj.refreshTableDataList) return;
        $.post("/api/org/listGroupDataByType",me.defaultParams,function(res){
          tableObj.refreshTableDataList(res.result);
        })
      },
      addTitle(){
        this.resetFields();
        if(this.userInfo.developer){
          this.form.unitId = this.userInfo.owner;
          this.form.unitName = "美络科技";
        }else{
          this.form.unitId = this.selUnitId || this.$store.getters.curUnit[0].id ;
          this.form.unitName = this.selUnitName || this.$store.getters.curUnit[0].name;
        }
        this.form.create_user = this.userInfo.name;
        this.form.code = $lang(this.selCode || "外单位");
        this.form.create_user = this.userInfo.loginId;
        this.showDialog('titleDialog');

      },
      openForm:function(data){
        let fd = {};
        fd = _.assign(fd,data)
        this.form = fd;
        this.showDialog('titleDialog');
      },
      deleteGroup(data){
        let me = this;
        if(!data || data.length===0){
          this.mwMsg('warning', $lang('请选择数据'));
          return;
        }
        let ids = [];
        $.each(data,function(i,d){
          ids.push(d.id);
        })
        me.mwConfirm($lang('您确定要删除此外部单位吗?')).then(() => {
          PF.ajax("api/org/deleteAddressBookGroup",ids).then((res)=>{
              if (res.result > 0) {
                me.mwMsg($lang("删除成功"));
                me.refreshData();
              }
          });
        })
      },
      closeTitleDialog(){
        this.resetFields();
        this.closeDialog('titleDialog');
      },

      refreshData(noRefreshTree){
        if(!noRefreshTree){
          // this.defaultTreeParams.t = Date.now();
          this.mwRef('groupTree').refresh();
        }else{
          this.reloadData();
        }
      },
      saveTitle(){
        var me=this;
        me.mwRef('ruleForm').validate((valid) => {
          if (valid) {
            me.form.type = "personal_outerOrg";
            $.post("/api/org/saveOuterOrg",this.form).then(function(data){
                me.mwRef('titleDialog').hide();
                me.refreshData();
                me.resetFields();
            });
          }
        });
      },
      handleSortCommand(command) {
        let me = this;
        let multipleSelection =  this.mwRef('aa').getMultipleSelection();
        me.doSortSN(command,multipleSelection);
      },
      sort(){
          this.doSortSN("sort");
      },
      up(data){
        this.doSortSN("up",data);
      },
      down(data){
        this.doSortSN("down",data);
      },
      top(data){
        this.doSortSN("top",data);
      },
      bottom(data){
        this.doSortSN("bottom",data);
      },
      doSortSN(flag,data){
        let me = this;
        let params =me.defaultParams;
        params.flag = flag;
        if(flag != "sort"){
          if(!data || data.length != 1){
            this.mwMsg('warning', $lang('请选择一条数据'));
            return;
          }
          params.id = data[0].id;
        }
        params.targetName="外部单位";
        PF.ajax("api/org/updateGroupSN",params).then((res)=>{
          if(res.result){
             me.refreshData(true);
          }
        });
      },
      showDialog(a){
        this.mwRef(a).show();
      },
      closeDialog(a){
        this.mwRef(a).hide();
      },
      closeGroupDialog(){
        this.closeDialog("dialog");
      },
      resetFields() {
        var me = this;
        me.form.id = "";
        me.form.unitName = "";
        me.form.unitId = "";
        me.form.code = "";
        me.form.name = "";
        me.form.sn = "";
        me.form.create_user = "";
        me.form.identifier = "";
      }
    }
  }
</script>
<style scoped>
.toolbar-dialog {
      padding: 5px 10px;
      line-height: 35px ;
      margin-bottom: 5px;
      background-color: #f1f1f1;
   }

  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 80%;
  }

  .el-form-item__label {
    line-height: 30px;
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/personalOuterOrg.vue